import React, { useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import PropTypes from "prop-types";
import { ProviderTableRow } from "./ProviderTableRow";
import OrderingArrow from "../../../../global/OrderingArrow";

export const columns = [
  "Name",
  "Address",
  "Rating",
  "In Network",
  "Provider Types",
  "Options",
];

export const ProviderList = ({
  referenceForScrolling,
  data,
  filters,
  updateFilter,
  handleClick
}) => {
  const orderingValQuery = filters.get("ordering") ?? "name";
  const [orderingVal, setOrderingVal] = useState(orderingValQuery);
  
  const updateOrdering = (val)=>{
    setOrderingVal(val);
    updateFilter("ordering", val);
  }
  
  return (
    <TableContainer
      ref={referenceForScrolling}
      component={Paper}
      className="relative max-h-[70vh]"
    >
      <Table aria-label="simple table" stickyHeader>
        <TableHead>
          <TableRow>
            {columns.map((column, idx) => {
              if (idx === 0) {
                return (
                  <TableCell
                    key={column}
                    align="center"
                    className="sticky left-0 z-20 bg-white whitespace-nowrap shadow-[-1px_-5px_6px_lightgray]"
                  >
                    {column}
                    <OrderingArrow
                      orderingVal={orderingVal}
                      setOrderingVal={updateOrdering}
                      val={"name"}
                    />
                  </TableCell>
                );
              }
              if (idx === columns.length - 1) {
                return (
                  <TableCell
                    key={column}
                    align="center"
                    className="sticky left-0 z-20 bg-white whitespace-nowrap shadow-[2px_-5px_6px_lightgray]"
                  >
                    {column}
                  </TableCell>
                );
              }

              return (
                <TableCell
                  key={column}
                  align="center"
                  className="whitespace-nowrap"
                >
                  {column}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.length > 0 &&
            data.map((row, idx) => (
              <ProviderTableRow
                key={'item_'+ row.pk + '_' + idx}
                data={row}
                onDetailClick={handleClick}
              />
            ))}
          {data?.length === 0 && (
            <TableRow>
              <TableCell
                colSpan={columns.length}
                data-testid="no-providers-found"
              >
                No Providers Found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

ProviderList.propTypes = {
  referenceForScrolling: PropTypes.object,
  data: PropTypes.array,
  filters: PropTypes.object,
  updateFilter: PropTypes.func,
  handleClick: PropTypes.func,
};
